import { NetworkMotif } from "@/components/governance/NetworkMotif";

// Full-bleed navy legal-identity panel. Rows with no value are omitted entirely
// (no "to be confirmed" / placeholder language is ever shown). Marked data-nav-dark
// so the site header switches to its light theme while this section is behind it.
export function LegalIdentityPanel({ eyebrow, name, intro, fields }) {
  const rows = (fields || []).filter((f) => f.value && f.value.trim());
  return (
    <section id="legal-identity" className="scroll-mt-24 border-y border-white/10 bg-[var(--navy)] py-16 text-[var(--ivory)] lg:py-24" data-nav-dark data-testid="legal-identity-panel">
      <div className="container-dbrf relative overflow-hidden">
        <NetworkMotif className="pointer-events-none absolute -right-4 top-0 hidden h-56 w-56 text-[var(--cyan)] opacity-[0.10] lg:block" />
        <p className="eyebrow relative !text-[var(--cyan)]">{eyebrow}</p>
        <h2 className="relative mt-3 font-display font-bold" style={{ fontSize: "clamp(1.7rem,2.8vw,2.6rem)" }}>{name}</h2>
        <p className="relative mt-5 max-w-3xl text-[var(--ivory)]/80" style={{ fontSize: "1.05rem", lineHeight: 1.7 }}>{intro}</p>
        <dl className="relative mt-10 grid gap-x-10 gap-y-7 sm:grid-cols-2 lg:mt-12 lg:grid-cols-3">
          {rows.map((r) => (
            <div key={r.label} data-testid={`legal-field-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <dt className="font-mono text-[0.7rem] uppercase tracking-[0.14em] text-[var(--cyan)]/85">{r.label}</dt>
              <dd className="mt-1.5 whitespace-pre-line font-medium text-[var(--ivory)]" style={{ lineHeight: 1.55 }}>{r.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
